// extracted by mini-css-extract-plugin
export default {"imageContent":"StyledImage_imageContent__I0E03","peelShadow":"StyledImage_peelShadow__tkYrR","dropShadow":"StyledImage_dropShadow__ZZV9X"};